/**
 * covid19_dashboard copyright © 2020
 * Created by mauromarini on 07/08/20
 * Repository: http://github.com/marinimau/covid19_dashboard
 * Location: Baratili San Pietro
 */

const RemoteUrls = {
    dashboard_covid_vaccine: 'https://marinimau.github.io/covid19_dashboard_vaccini',
    national: 'https://raw.githubusercontent.com/pcm-dpc/COVID-19/master/dati-json/dpc-covid19-ita-andamento-nazionale.json',
    regionsLatest: 'https://raw.githubusercontent.com/pcm-dpc/COVID-19/master/dati-json/dpc-covid19-ita-regioni-latest.json',
    regions: 'https://raw.githubusercontent.com/pcm-dpc/COVID-19/master/dati-json/dpc-covid19-ita-regioni.json',
    donate: 'https://www.paypal.com/paypalme/marinimau',
    repository: 'https://github.com/marinimau/covid19_dashboard',
    data: 'https://github.com/pcm-dpc/COVID-19',
    contact: 'https://github.com/marinimau/covid19_dashboard/issues'
}

export default RemoteUrls;